import React from "react";
import "./engineRepair.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function EngineRepair() {
  return (
    <>
    <Helmet>
      <title>Best Engine Repair Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Get professional engine repair service in Palwal. AutoCare provides reliable car repair services with expert mechanics and genuine parts."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/engine-repair"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT CONTENT */}
        <div className="textContent">
          <h1>Best Engine Repair Service in Palwal</h1>

          <p>
            Facing engine issues? Get reliable and professional
            <strong> car engine repair service</strong> at
            <span className="highlight"> AutoCare</span>.
            We are known as one of the <strong>best car repair shops in Palwal</strong>,
            providing expert <span className="highlight">auto care and engine diagnostics</span>.
          </p>

          <h2>Professional Car Engine Repair</h2>
          <p>
            Our engine repair service includes complete engine diagnostics,
            fault detection, repair, and performance restoration.
            Whether it’s overheating, unusual noise, power loss, or oil leakage,
            our skilled technicians ensure your car runs smoothly again.
          </p>

          <h2>Engine Problems We Fix</h2>
          <ul>
            <li>Engine overheating & coolant issues</li>
            <li>Low engine power & poor mileage</li>
            <li>Oil leakage & excessive oil consumption</li>
            <li>Engine noise, vibration & knocking</li>
            <li>Check engine light diagnostics</li>
            <li>Timing belt & engine component repair</li>
          </ul>

          <h2>Why Choose AutoCare for Engine Repair?</h2>
          <ul>
            <li>Trusted <span className="highlight">engine repair service in Palwal</span></li>
            <li>Advanced engine diagnostic tools</li>
            <li>Experienced and certified mechanics</li>
            <li>Genuine spare parts & transparent pricing</li>
            <li>One-stop <span className="highlight">Auto Care in Palwal</span> solution</li>
          </ul>

          <h2>Engine Repair Near You</h2>
          <p>
            Searching for the <span className="highlight">best engine repair near me</span>?
            Choose <strong>AutoCare</strong> for affordable, fast, and dependable
            <strong> car engine repair services</strong> in Palwal.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Engine Repair Service
            </Link>
          </button>
        </div>

        {/* IMAGE */}
        <div className="imageContent">
          <img
            src="/carServiceImages/EngineRepair.webp"
            alt="Best Engine Repair Service in Palwal | AutoCare"
          />
        </div>

      </div>
    </section>
    </>
  );
}
